module.exports = __webpack_public_path__ + "videos/3d-export_cn.b63dc65.mp4";